export const EMAIL_VERIFICATION_PAGE = {
    EMAIL_SENT_SUCCESS_MESSAGE: {
        key: 'EMAIL_SENT_SUCCESS_MESSAGE',
        value: 'Email sent successfully. Please check your email'
    },
    EMAIL_VERIFICATION_FAILED_TITLE: {
        key: 'EMAIL_VERIFICATION_FAILED_TITLE',
        value: 'EMAIL VERIFICATION FAILED'
    },
    WELCOME_TO_PDS_TITLE: {
        key: 'WELCOME_TO_PDS_TITLE',
        value: 'WELCOME TO PERFECT DOC STUDIO'
    },
    EMAIL_SENT_DESCRIPTION: {
        key: 'EMAIL_SENT_DESCRIPTION',
        value: 'We have sent you a verification link in the email. Request you to verify your email to proceed further'
    },
    WAITING_FOR_VERIFICATION_ALT_TEXT: {
        key: 'WAITING_FOR_VERIFICATION_ALT_TEXT',
        value: "Waiting for email verification"
    },
    RESEND_IN_BUTTON: {
        key: 'RESEND_IN_BUTTON',
        value: 'Resend email in '
    },
    RESEND_EMAIL_BUTTON: {
        key: 'RESEND_EMAIL_BUTTON',
        value: 'RESEND EMAIL'
    },
    EMAIL_VERIFIED_ERROR_MESSAGE: {
        key: 'EMAIL_VERIFIED_ERROR_MESSAGE',
        value: 'This email is already verified'
    },
    SENDING_EMAIL_MESSAGE: {
        key: 'SENDING_EMAIL_MESSAGE',
        value: 'Sending email'
    },
    SOMETHING_WENT_WRONG_ERROR_MESSAGE: {
        key: 'SOMETHING_WENT_WRONG_ERROR_MESSAGE',
        value: 'Ooops! something went wrong'
    }
};